export type NonSelectableViewProps = { children: React.ReactNode };

export function NonSelectableView({ children }: NonSelectableViewProps) {
    return <div className='noselect'>{children}</div>;
}
